{{'components.refresh-button.label' | l10n }}
<svg class="refresh-button_icon"><use xlink:href="#refresh"></use></svg>
